const format = (v) => (String(v).length === 1 ? `0${v}` : v)

const insert = (el, { h, m, s }) => {
  const hours = el.querySelector(".hours")
  if (hours && hours.textContent !== String(h)) hours.textContent = h
  const minutes = el.querySelector(".minutes")
  if (minutes && minutes.textContent !== String(m)) minutes.textContent = m
  const seconds = el.querySelector(".seconds")
  if (seconds && seconds.textContent !== String(s)) seconds.textContent = s
}

class Countdown {
  constructor(el, updateTs, tc, hoursMins = false) {
    this.el = el
    this.updateTs = updateTs
    this.tc = tc
    this.timer = null
    this.format = hoursMins ? String : format
  }

  start() {
    this.update()
    this.timer = setTimeout(() => {
      this.start()
    }, 1000)

    return this
  }

  stop() {
    clearTimeout(this.timer)

    return this
  }

  update() {
    const delta = this.updateTs - Math.round(Date.now() / 1000 + this.tc)
    const h = this.format(Math.abs(Math.floor(delta / 3600)))
    const m = this.format(Math.abs(Math.floor((delta % 3600) / 60)))
    const s = this.format(Math.abs(delta % 60))
    insert(this.el, { h, m, s })

    return this
  }
}

export default function setListeners() {
  const { FCGON } = window
  if (!FCGON) return []

  const { forecastUpdateTime, serverTime } = FCGON
  if (!forecastUpdateTime || !serverTime) return []

  const timeCorrection = serverTime - Date.now() / 1000
  const els = document.querySelectorAll("[data-countdown]")

  return [...els].map((el) => {
    const hoursMins = el.dataset.countdown === "hm"
    return new Countdown(el, forecastUpdateTime, timeCorrection, hoursMins).start()
  })
}
